export default "/build/images/032-5-100x100.png?2418ce4ee5b99ae08c9bb1021398348c";